$(document).ready(function () {
    if (
        ($(".header-menu li.has-child-menu").each(function () {
            $(this).find("a").first().append('<span class="open-submenu"><i class="fas fa-angle-down"></i></span>');
        }),
        $(".hero-slider").slick({ slidesToShow: 1, infinite: !1, arrows: !1, dots: !0, autoplay: !0, autoplaySpeed: 8e3, rows: 0 }),
        $(".hero-slider").on("init", function () {
            !(function () {
                slickSlider = $(".hero-slider");
                let e = slickSlider.find(".slick-slide"),
                    i = 0;
                e.each(function () {
                    let e = (100 * $(this).height()) / $(window).width();
                    i < e && (i = e);
                }),
                    e.css("height", i + "vw");
            })();
        }),
        $(".video-slider").slick({ slidesToShow: 1, arrows: !0 }),
        $(".testimonials-slider").slick({ slidesToShow: 1, arrows: !1, infinite: !1, mobileFirst: !0, responsive: [{ breakpoint: 1e3, settings: { slidesToShow: 4 } }] }),
        $(".slider-inside").slick({ slidesToShow: 1, arrows: !0, infinite: !0, mobileFirst: !0, responsive: [{ breakpoint: 1e3, settings: { slidesToShow: 3 } }] }),
        $(".partnerships .partners").slick({
            slidesToShow: 1,
            arrows: !0,
            infinite: !0,
            mobileFirst: !0,
            slidesToShow: 2,
            slidesToScroll: 2,
            responsive: [{ breakpoint: 1e3, settings: { slidesToShow: 4, slidesToScroll: 4, variableWidth: !0 } }],
        }),
        $(".inside-omegas .cards").slick({ slidesToShow: 1, arrows: !1, dots: !0, infinite: !1, mobileFirst: !0, responsive: [{ breakpoint: 1e3, settings: "unslick" }] }),
        $(".menu-toggle").click(function (e) {
            console.log("Mobile toggle"), $(this).toggleClass("open"), $(".mobile-group").slideToggle(300);
        }),
        $(window).width() > 768)
    ) {
        $(".has-child-menu").hover(
            function (e) {
                console.log("Menu Hover"), !1, $(this).find("ul").show(0);
            },
            function (e) {
                !0 && $(this).find("ul").hide(0);
            }
        ),
            $(".has-child-menu > ul").hover(function (e) {
                console.log("UL toggle"), !1;
            }),
            $(document).mouseup(function (e) {
                var i = $(".header-menu li ul, .open-submenu");
                i.is(e.target) || 0 !== i.has(e.target).length || (console.log("Mouse Up Hide"), $(".header-menu li ul").hide());
            });
    } else {
        $(".has-child-menu > a > .open-submenu").click(function (e) {
           e.preventDefault();
            const parentLi = $(this).closest("li.has-child-menu");
              if (parentLi.hasClass("open")) {
                  parentLi.find("ul").hide(); 
                  parentLi.removeClass("open"); 
              } else {
                  parentLi.find("ul").show();
                  parentLi.addClass("open"); 
              }
        });
        let e = 0;
        $(".header-menu .has-child-menu a").on("click", function (i) {
            console.log(i.currentTarget.text), "Blog" === i.currentTarget.text && 0 == e && (event.preventDefault(), e++);
        });
    }
    $(".video-slider").on("beforeChange", function (e, i, o, t) {
        $("video").trigger("pause");
    }),
        $(document).on("click", ".play-btn", function () {
            var e = $(this).prev().prev().get(0);
            console.log($(this).prev()), $(this).hide(), $(this).prev().hide(), e.play();
        }),
        $(document).on("click", "video", function () {
            var e = $(this).prev().prev().get(0);
            e.paused ? e.play() : e.pause();
        }),
        $(".video-screen").hide(),
        $("body").on("click", "#AddToCartForm .selection .select ul li", function () {
            if (0 != $("#pack4qty").length) {
                var e = $("#pack4qty").text();
                e = parseInt(e);
            } else e = 0;
            var i = 2,
                o = $("#AddToCartForm .selection .select .active").text();
            o.indexOf("4-Pack Box (Save 15%)") >= 0
                ? (setTimeout(function () {
                      $("#AddToCartForm .bold-ro__frequency-num").val("4").change();
                  }, 25),
                  1 == e && (i = 1),
                  2 == e && $("#AddToCart").attr("disabled", !0),
                  console.log(e),
                  $("#AddToCartForm .selection .number > input").attr({ max: i }),
                  $("#AddToCartForm .selection .number > input").val() > i && $("#AddToCartForm .selection .number > input").val(i))
                : o.indexOf("2-Pack Box (Save 10%)") >= 0
                ? setTimeout(function () {
                      $(".bold-ro__frequency-num").val("2").change();
                  }, 25)
                : (setTimeout(function () {
                      $(".bold-ro__frequency-num").val("1").change();
                  }, 25),
                  $("#AddToCartForm .selection .number > input").removeAttr("max"),
                  $("#AddToCart").attr("disabled", !1));
        }),
        $(".limitedQty").keyup(function () {
            $(this).val() > 2 && ($(this).val(2), $(this).next(".qtyNotice").show());
        }),
        $(".limitedQty").blur(function () {
            $(this).val() > 2 && ($(this).val(2), $(this).next(".qtyNotice").show());
        }),
        $(".limitedQty").change(function () {
            $(this).val() > 2 && ($(this).val(2), $(this).next(".qtyNotice").show());
        });
});
